import { DrilldownTableColumnDef } from 'features/drilldown/components/table/config/DrilldownTableSchema'
import {
  DEFAULT_TABLE_PANEL_SHARED_FIELD_DATA,
  DrilldownTablePanelData,
} from 'features/drilldown/components/table/DrilldownTable'

type SiteTablePanelData = DrilldownTablePanelData

const SITE_TABLE_COLUMN_DEFS: ReadonlyArray<DrilldownTableColumnDef> = [
  {
    title: 'Site',
    field: 'site.name',
    copyField: 'site.name',
  },
  {
    title: 'Site ID',
    field: 'site.id',
    copyField: 'site.id',
  },
  {
    title: 'Organization',
    field: 'organization.name',
    copyField: 'organization.name',
  },
  {
    title: 'Address',
    field: 'site.address',
  },
]

export const DEFAULT_SITE_TABLE_PANEL_DATA: SiteTablePanelData = {
  ...DEFAULT_TABLE_PANEL_SHARED_FIELD_DATA,
  columns: SITE_TABLE_COLUMN_DEFS,
  title: 'Sites',
  isPinned: true,
  groupByType: 'site',
}
